import { ModalTypes } from "./constants";
import styled, { css } from "styled-components";
import { hexToRgba } from "@icarros/utils-react";
import { ids } from "@icarros/theme-react";
const { color, foundation_size, opacity, size, spacing } = ids || {};
const getModalWidth = (type) => {
    return css `
    width: ${type === ModalTypes.horizontal ? "672px" : "438px"};
    @media screen and (max-width: ${foundation_size.screen.size_screen_768}) {
      width: calc(100% - 24px);
    }
  `;
};
export const ModalContainer = styled.dialog `
  border-radius: ${size.general.ids_size_general_12x};
  border-color: transparent;
  padding: ${({ stickyFooter }) => stickyFooter
    ? `${spacing.ids_spacing_6x} ${spacing.ids_spacing_6x} 0`
    : spacing.ids_spacing_6x};
  background-color: ${color.backgrounds.ids_color_bg_base};
  ${({ modalType }) => getModalWidth(modalType)};
  gap: ${size.general.ids_size_general_16x};
  display: flex;
  flex-direction: column;
  z-index: 101;
  margin: 0 auto;
  max-height: 100%;
  max-width: 100%;
  overflow-y: auto;
`;
export const Overlay = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_medium)};
  width: ${foundation_size.percent.size_percent_100};
  height: ${foundation_size.percent.size_percent_100};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 101;
`;
export const ModalContent = styled.div `
  display: flex;
`;
//# sourceMappingURL=Modal.style.js.map